import "./License.scss";
import { CheckboxRadio, showToast, SkeletonList } from "ui-components";
import { useState, useEffect, useContext } from "react";
import { updateLicenseStatus } from "../../../service/License/License";
import { systemPreferenceContext } from "../../../context/SystemPreference/SystemPreference";

interface LicenseProps {
  licenseList: any[];
  setLicenseWithStatus: React.Dispatch<React.SetStateAction<any[]>>;
}

const License = ({ licenseList, setLicenseWithStatus }: LicenseProps) => {
  const [licenseStatus, setLicenseStatus] = useState<Record<string, boolean>>(
    {},
  );
  const { getLicenseWithStatusApi } = useContext(systemPreferenceContext);
  const [loading, setLoading] = useState(true);
  const getLicenseWithStatus = JSON.parse(
    localStorage.getItem("licenseWithStatus") ?? "[]",
  );
  useEffect(() => {
    setLoading(true);
    const storedData = JSON.parse(
      localStorage.getItem("licenseWithStatus") ?? "[]",
    );
    const statusMap: Record<string, boolean> = {};
    licenseList.forEach((item) => {
      const match = storedData.find(
        (stored: any) => stored.licenseId === item.licenseId,
      );
      statusMap[item.licenseId] = match ? match.isEnabled : false;
    });
    setLicenseStatus(statusMap);
    setLoading(false);
  }, [licenseList]);

  const updateLicenseStatusApi = async (data: any) => {
    try {
      const res = await updateLicenseStatus(data);
      if (res?.status === 200) {
        setLicenseStatus((prev) => ({
          ...prev,
          [data.licenseId]: data.isEnabled,
        }));

        const updatedList = getLicenseWithStatus.map((item: any) =>
          item.licenseId === data.licenseId
            ? { ...item, isEnabled: data.isEnabled }
            : item,
        );
        if (updatedList.length) {
          localStorage.setItem(
            "licenseWithStatus",
            JSON.stringify(updatedList),
          );
          setLicenseWithStatus(updatedList);
        } else {
          const getLicenseData = await getLicenseWithStatusApi();
          setLicenseWithStatus(getLicenseData);
        }
        showToast(res?.customMessage, "success");
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  return (
    <div className="licenseSec">
      {loading ? (
        <div className="loader-overlay">
          {Array.from({ length: 5 }).map((_, index) => (
            <SkeletonList
              key={`skeleton-${index}`}
              numberOfTitles={1}
              numberofTextLines={1}
              titleSize={18}
              textSize={12}
              thumbnailHeight={100}
              thumbnailWidth={100}
              itemsGap={20}
            />
          ))}
        </div>
      ) : (
        <>
          {licenseList?.map((item) => (
            <div className="staffAugEnable" key={item?.licenseId}>
              <div className="d-flex flex-column">
                <span className="staffAugText">{item?.name}</span>
                {/* <span className="staffAugDescription">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </span> */}
              </div>
              <div className="toggleSwitch">
                <CheckboxRadio
                  type="switch"
                  onChange={() =>
                    updateLicenseStatusApi({
                      licenseId: item?.licenseId,
                      isEnabled: !licenseStatus[item.licenseId],
                    })
                  }
                  checked={licenseStatus[item.licenseId] || false}
                />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default License;
